export function studioDate(value?: string | null) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
  if (!match) return '';
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  return new Intl.DateTimeFormat('en-ZA', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}

export function studioWhen(value?: string | null) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return studioDate(value);
  return new Intl.DateTimeFormat('en-ZA', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function activityLabel(action?: string) {
  const labels: Record<string, string> = {
    created: 'Started the quotation',
    recorded: 'Recorded an existing booking',
    edited: 'Edited the quotation',
    accepted: 'Accepted the quotation',
    issued: 'Issued the quotation',
    revised: 'Revised the quotation',
    duplicated: 'Duplicated the quotation',
    superseded: 'Superseded the quotation',
    expired: 'Quotation expired',
    declined: 'Declined the quotation',
    cancelled: 'Cancelled the quotation',
    revoked: 'Revoked the client link',
    'link-rotated': 'Replaced the client link',
    archived: 'Archived the quotation',
    unarchived: 'Restored from archive',
    deleted: 'Moved to Recently Deleted',
    'soft-deleted': 'Moved to Recently Deleted',
    restored: 'Restored the quotation',
    test: 'Updated the test flag',
    'marked-test': 'Marked as a test',
    'unmarked-test': 'Unmarked as a test',
    'contact-updated': 'Updated the contact details',
    'payment-terms-updated': 'Changed the deposit',
    'shoot-request-updated': 'Updated the date or place',
    'shoot-date-chosen': 'Chose a shoot date',
    'shoot-time-chosen': 'Chose a start time',
    'shoot-location-chosen': 'Chose a place',
  };
  const key = String(action || '');
  return labels[key] || key.replace(/-/g, ' ');
}

export function paymentStateLabel(type?: string, status?: string) {
  if (type === 'refund' && status === 'complete') return 'Refunded';
  if (status === 'complete') return 'Verified';
  if (status === 'pending' || status === 'initiated' || status === 'processing') return 'Pending';
  if (status === 'failed' || status === 'cancelled') return 'Not verified';
  return 'Pending';
}
